// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-input-disabled,
.ant-input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff !important;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
  color: black;
}

.ant-select-multiple.ant-select-lg
  .ant-select-selection-item-content {
  display: inline-block;
  margin-inline-end: 4px;
  overflow: hidden;
  white-space: pre;
  text-overflow: ellipsis;
  color: black;
}
.MuiInputBase-root.Mui-disabled{
  background: #fff !important;
}
.ant-input-affix-wrapper-disabled{
  background: #fff !important;
}
.ant-select-disabled .ant-select-selector {
  background: #fff !important; /* your custom background */
  cursor: not-allowed !important;
  color :black !important;
}

.css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
    opacity: 1 !important;
    -webkit-text-fill-color: initial !important;
  }
  
  .MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
    opacity: 1 !important;
    -webkit-text-fill-color: initial !important;
  }
  .css-1h51icj-MuiAutocomplete-root
    .MuiOutlinedInput-root.MuiInputBase-sizeSmall
    .MuiAutocomplete-input {
    color: black;
  }
  .ant-checkbox-disabled
    .ant-checkbox-inner:after {
    border-color: black;
  }
  
  .ant-radio-wrapper
    .ant-radio-disabled.ant-radio-checked
    .ant-radio-inner::after {
    transform: scale(0.5);
    background-color: black;
  }
  .MuiInputBase-input.Mui-disabled {
    /* opacity: 1; */
    color: black;
  }
  
  .ant-checkbox-disabled + span {
    color: black;
  }
  .ant-radio-wrapper-disabled {
    cursor: not-allowed;
    color: black;
  }
  .ant-select-multiple
    .ant-select-selection-item-content {
    display: inline-block;
    margin-inline-end: 4px;
    overflow: hidden;
    white-space: pre;
    text-overflow: ellipsis;
    color: black;
  }
  .css-6od3lo-MuiChip-label {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 12px;
    padding-right: 12px;
    white-space: nowrap;
    color: black;
  }
  .css-1mywu95-MuiButtonBase-root-MuiChip-root.Mui-disabled {
    opacity: 0;
    pointer-events: none;
    color: black;
  }`, "",{"version":3,"sources":["webpack://./src/components/NPD/Index.css"],"names":[],"mappings":"AAAA;;EAEE,0BAA0B;EAC1B,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B,EAAE,2BAA2B;EACxD,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;EAC7C;;EAEA;IACE,qBAAqB;IACrB,2CAA2C;EAC7C;EACA;;;IAGE,YAAY;EACd;EACA;;IAEE,mBAAmB;EACrB;;EAEA;;;IAGE,qBAAqB;IACrB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;;IAEE,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,UAAU;IACV,oBAAoB;IACpB,YAAY;EACd","sourcesContent":[".ant-input-disabled,\n.ant-input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff !important;\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n  color: black;\n}\n\n.ant-select-multiple.ant-select-lg\n  .ant-select-selection-item-content {\n  display: inline-block;\n  margin-inline-end: 4px;\n  overflow: hidden;\n  white-space: pre;\n  text-overflow: ellipsis;\n  color: black;\n}\n.MuiInputBase-root.Mui-disabled{\n  background: #fff !important;\n}\n.ant-input-affix-wrapper-disabled{\n  background: #fff !important;\n}\n.ant-select-disabled .ant-select-selector {\n  background: #fff !important; /* your custom background */\n  cursor: not-allowed !important;\n  color :black !important;\n}\n\n.css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {\n    opacity: 1 !important;\n    -webkit-text-fill-color: initial !important;\n  }\n  \n  .MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {\n    opacity: 1 !important;\n    -webkit-text-fill-color: initial !important;\n  }\n  .css-1h51icj-MuiAutocomplete-root\n    .MuiOutlinedInput-root.MuiInputBase-sizeSmall\n    .MuiAutocomplete-input {\n    color: black;\n  }\n  .ant-checkbox-disabled\n    .ant-checkbox-inner:after {\n    border-color: black;\n  }\n  \n  .ant-radio-wrapper\n    .ant-radio-disabled.ant-radio-checked\n    .ant-radio-inner::after {\n    transform: scale(0.5);\n    background-color: black;\n  }\n  .MuiInputBase-input.Mui-disabled {\n    /* opacity: 1; */\n    color: black;\n  }\n  \n  .ant-checkbox-disabled + span {\n    color: black;\n  }\n  .ant-radio-wrapper-disabled {\n    cursor: not-allowed;\n    color: black;\n  }\n  .ant-select-multiple\n    .ant-select-selection-item-content {\n    display: inline-block;\n    margin-inline-end: 4px;\n    overflow: hidden;\n    white-space: pre;\n    text-overflow: ellipsis;\n    color: black;\n  }\n  .css-6od3lo-MuiChip-label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding-left: 12px;\n    padding-right: 12px;\n    white-space: nowrap;\n    color: black;\n  }\n  .css-1mywu95-MuiButtonBase-root-MuiChip-root.Mui-disabled {\n    opacity: 0;\n    pointer-events: none;\n    color: black;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
